import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ShopMerch } from "@/components/ShopMerch";
import { Shirt, Users, HandHeart, ArrowRight } from "lucide-react";

export default function SostienicilPage() {
  return (
    <Layout>
      <section className="bg-[#1f2d22] text-white py-16 sm:py-20" data-testid="sostieni-header">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-5">
            <HandHeart className="w-3.5 h-3.5 text-[#E8C9A0]" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
              Sostieni l'associazione
            </span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight">
            Aiutaci a far <span className="italic font-light text-[#E8C9A0]">partire le attività.</span>
          </h1>
          <p className="mt-5 text-base sm:text-lg text-white/75 max-w-2xl leading-relaxed">
            Con l'acquisto delle nostre <strong className="text-white">magliette ufficiali</strong>
            contribuisci alle spese fondamentali per il funzionamento dell'associazione e alle attività sul
            territorio. Diventare socio o volontario è invece gratuito.
          </p>
        </div>
      </section>

      {/* Tre vie */}
      <section className="py-14 sm:py-20 bg-[#FBF9F6] border-b border-[#E5E1D8]">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 grid sm:grid-cols-3 gap-5">
          {[
            { icon: Shirt, title: "Magliette", desc: "Le magliette ufficiali dell'associazione: sostieni le spese fondamentali.", to: "#shop", accent: "#C15C3D" },
            { icon: Users, title: "Diventa socio", desc: "Adesione gratuita. Partecipa attivamente alla vita associativa secondo lo Statuto.", to: "/associarsi", accent: "#2E4F3B" },
            { icon: HandHeart, title: "Volontariato", desc: "Dona il tuo tempo e le tue competenze per il territorio.", to: "/partecipa", accent: "#C19A3D" },
          ].map((c) => {
            const Icon = c.icon;
            const Wrapper = c.to.startsWith("#") ? "a" : Link;
            const props = c.to.startsWith("#") ? { href: c.to } : { to: c.to };
            return (
              <Wrapper
                key={c.title}
                {...props}
                data-testid={`sostieni-card-${c.title.toLowerCase().replace(/\s/g, "-")}`}
                className="group flex flex-col bg-white border-2 border-[#E5E1D8] hover:border-[#2E4F3B] rounded-2xl p-6 sm:p-7 transition-all hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-white mb-5" style={{ backgroundColor: c.accent }}>
                  <Icon className="w-7 h-7" strokeWidth={1.7} />
                </div>
                <h3 className="font-display text-xl sm:text-2xl font-black text-[#1A1A1A] leading-tight mb-3">{c.title}</h3>
                <p className="text-sm text-[#5C5C5C] leading-relaxed flex-1">{c.desc}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-[#2E4F3B] group-hover:gap-3 transition-all">
                  Scopri
                  <ArrowRight className="w-4 h-4" />
                </span>
              </Wrapper>
            );
          })}
        </div>
      </section>

      {/* Shop completo */}
      <div id="shop">
        <ShopMerch />
      </div>
    </Layout>
  );
}
